import { Box, Button, TextField } from '@mui/material'
import { FormEvent, FormEventHandler } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ResetPasswordData } from '../../types/auth'

export interface ResetPasswordFormProps {
  onSubmit: (data: ResetPasswordData) => void
}

export function ResetPasswordForm(props: ResetPasswordFormProps): React.ReactElement {

  const { t } = useTranslation()

  const onSubmit: FormEventHandler<HTMLFormElement> = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const target = e.target as typeof e.target & {
      email: { value: string }
    }

    const data: ResetPasswordData = {
      email: target.email.value,
    }

    props.onSubmit(data)
  }

  return (
    <Box component="form" onSubmit={onSubmit}>
      <TextField
        margin="normal"
        fullWidth
        name="email"
        label={t('Email')}
        type="email"
        id="email"
      />
      <Button type="submit" sx={{ mt: 3 }} fullWidth variant="contained"><Trans>Send A Link</Trans></Button>
    </Box>
  )
}
